/* Suitality quote list: add to quote without leaving the page, quote drawer next to the cart, hand-off to the quote request form. No dependencies. */
(function () {
  'use strict';

  var KEY = 'suitality.quote.v1';
  var MAX = 40;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function load() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }
  var items = load();
  function save() {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {}
    render();
    document.dispatchEvent(new CustomEvent('quote:change', { detail: { items: items.slice() } }));
  }
  function count() { return items.reduce(function (n, i) { return n + 1; }, 0); }
  function find(key) { for (var i = 0; i < items.length; i++) if (items[i].key === key) return i; return -1; }

  var api = {
    items: function () { return items.slice(); },
    add: function (p) {
      var key = String(p.id || p.handle);
      var at = find(key);
      var qty = Math.max(1, parseInt(p.qty, 10) || 1);
      if (at > -1) items[at].qty += qty;
      else {
        if (items.length >= MAX) return false;
        items.push({ key: key, id: p.id || '', handle: p.handle || '', title: p.title || '', variant: p.variant || '', vendor: p.vendor || '', img: p.img || '', url: p.url || '', qty: Math.max(qty, parseInt(p.min, 10) || 1), step: Math.max(1, parseInt(p.step, 10) || 1), pack: parseInt(p.pack, 10) || 0, min: Math.max(1, parseInt(p.min, 10) || 1) });
      }
      save();
      return true;
    },
    setQty: function (key, q) { var at = find(key); if (at < 0) return; q = parseInt(q, 10); var mn = items[at].min || 1; if (!q || q < mn) q = mn; items[at].qty = q; save(); },
    remove: function (key) { var at = find(key); if (at < 0) return; items.splice(at, 1); save(); },
    clear: function () { items = []; save(); },
    open: function () { openDrawer(); }
  };
  window.SuitalityQuote = api;

  function packText(it, q) {
    q = q == null ? it.qty : q;
    var pk = parseInt(it.pack, 10) || 0;
    if (pk > 1) return (q === 1 ? '1 pack' : q + ' packs') + ' of ' + pk + ' = ' + (q * pk) + ' units';
    if (pk === 1) return q === 1 ? '1 unit' : q + ' units';
    return q === 1 ? '1 item' : q + ' items';
  }
  function unitLabel(it) { var pk = parseInt(it.pack, 10) || 0; return pk > 1 ? 'packs of ' + pk : pk === 1 ? 'units' : 'items'; }
  window.SuitalityPackText = packText;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- Drawer ---------- */
  var drawer, overlay, list, lastFocus;
  function build() {
    overlay = document.createElement('div');
    overlay.className = 'sq-overlay';
    overlay.hidden = true;
    overlay.addEventListener('click', closeDrawer);
    drawer = document.createElement('aside');
    drawer.className = 'sq-drawer';
    drawer.id = 'QuoteDrawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-labelledby', 'QuoteDrawerTitle');
    drawer.hidden = true;
    drawer.innerHTML =
      '<div class="sq-drawer__head"><h2 class="sq-drawer__title" id="QuoteDrawerTitle">Your quote <span class="sq-drawer__n" data-quote-count-text></span></h2>' +
      '<button type="button" class="sq-icon-btn" data-quote-close aria-label="Close the quote"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
      '<p class="sq-drawer__lead">Add products, set the quantities you need, then send one request. Each supplier replies with prices, lead time and delivery.</p>' +
      '<ul class="sq-list" data-quote-list></ul>' +
      '<div class="sq-empty" data-quote-empty><p>Your quote is empty.</p><p>Use “Add to quote” on any product, then come back here to send one request.</p><a class="btn btn--secondary" href="/collections/all">Browse the catalogue</a></div>' +
      '<div class="sq-drawer__foot" data-quote-foot><p class="sq-drawer__note">No payment now. Prices are confirmed by each supplier.</p>' +
      '<a class="btn sq-drawer__send" href="/pages/request-for-quote?from=quote#quote">Request the quote</a>' +
      '<button type="button" class="s-link-btn sq-drawer__clear" data-quote-clear>Empty the quote</button></div>';
    document.body.appendChild(overlay);
    document.body.appendChild(drawer);
    list = drawer.querySelector('[data-quote-list]');
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-quote-close]')) { closeDrawer(); return; }
      if (e.target.closest('[data-quote-clear]')) { api.clear(); return; }
      var row = e.target.closest('[data-key]');
      if (!row) return;
      var key = row.dataset.key, it = items[find(key)];
      if (!it) return;
      if (e.target.closest('[data-quote-remove]')) { api.remove(key); return; }
      if (e.target.closest('[data-quote-minus]')) api.setQty(key, Math.max(it.min || it.step, it.qty - it.step));
      if (e.target.closest('[data-quote-plus]')) api.setQty(key, it.qty + it.step);
    });
    drawer.addEventListener('change', function (e) {
      var row = e.target.closest('[data-key]');
      if (row && e.target.matches('input')) api.setQty(row.dataset.key, e.target.value);
    });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeDrawer(); return; }
      if (e.key !== 'Tab') return;
      var f = drawer.querySelectorAll('a[href], button:not([disabled]), input');
      f = Array.prototype.filter.call(f, function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
  }
  function openDrawer() {
    if (!drawer) build();
    render();
    lastFocus = document.activeElement;
    overlay.hidden = false;
    drawer.hidden = false;
    document.documentElement.classList.add('sq-lock');
    requestAnimationFrame(function () { overlay.classList.add('is-open'); drawer.classList.add('is-open'); });
    var c = drawer.querySelector('[data-quote-close]');
    if (c) c.focus();
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('sq-lock');
    setTimeout(function () { overlay.hidden = true; drawer.hidden = true; }, reduce ? 0 : 220);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function render() {
    var n = count();
    document.querySelectorAll('[data-quote-count]').forEach(function (b) {
      b.textContent = n;
      b.classList.toggle('is-visible', n > 0);
    });
    document.querySelectorAll('[data-quote-open]').forEach(function (b) {
      b.setAttribute('aria-label', 'Quote, ' + n + (n === 1 ? ' product' : ' products'));
    });
    if (!drawer) return;
    drawer.querySelector('[data-quote-count-text]').textContent = n ? '(' + n + ')' : '';
    drawer.querySelector('[data-quote-empty]').hidden = n > 0;
    drawer.querySelector('[data-quote-foot]').hidden = n === 0;
    list.innerHTML = items.map(function (it) {
      return '<li class="sq-item" data-key="' + esc(it.key) + '">' +
        '<a class="sq-item__img" href="' + esc(it.url) + '">' + (it.img ? '<img src="' + esc(it.img) + '" alt="" width="64" height="64" loading="lazy">' : '') + '</a>' +
        '<div class="sq-item__body"><p class="sq-item__vendor">' + esc(it.vendor) + '</p>' +
        '<a class="sq-item__title" href="' + esc(it.url) + '">' + esc(it.title) + '</a>' +
        (it.variant ? '<p class="sq-item__variant">' + esc(it.variant) + '</p>' : '') +
        '<div class="sq-item__row"><div class="sq-qty"><button type="button" data-quote-minus aria-label="Decrease quantity of ' + esc(it.title) + '">−</button>' +
        '<input type="number" min="1" inputmode="numeric" value="' + it.qty + '" aria-label="Quantity of ' + esc(it.title) + '">' +
        '<button type="button" data-quote-plus aria-label="Increase quantity of ' + esc(it.title) + '">+</button></div>' +
        '<span class="sq-item__unit">' + esc(unitLabel(it)) + '</span>' +
        '<button type="button" class="s-link-btn sq-item__remove" data-quote-remove>Remove</button></div>' +
        '<p class="sq-item__total">' + esc(packText(it)) + (it.min > 1 ? ' · minimum ' + it.min : '') + '</p></div></li>';
    }).join('');
  }

  /* ---------- Toast and fly animation ---------- */
  var toast, toastTimer;
  function showToast(it) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'sq-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
      toast.addEventListener('click', function (e) { if (e.target.closest('[data-quote-view]')) { hideToast(); openDrawer(); } });
    }
    toast.innerHTML = (it.img ? '<img src="' + esc(it.img) + '" alt="" width="44" height="44">' : '') +
      '<div class="sq-toast__text"><strong>Added to your quote</strong><span>' + esc(it.title) + '</span></div>' +
      '<button type="button" class="btn btn--small" data-quote-view>View quote</button>';
    toast.classList.add('is-open');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 5000);
  }
  function hideToast() { if (toast) toast.classList.remove('is-open'); }

  function target() {
    var t = Array.prototype.filter.call(document.querySelectorAll('[data-quote-open]'), function (x) { return x.offsetParent !== null; })[0];
    return t;
  }
  function fly(fromEl, img) {
    var t = target();
    if (t) {
      t.classList.remove('is-bump');
      void t.offsetWidth;
      t.classList.add('is-bump');
    }
    if (reduce || !fromEl || !img || !t || !fromEl.getBoundingClientRect || !document.body.animate) return;
    var a = fromEl.getBoundingClientRect(), b = t.getBoundingClientRect();
    var ghost = document.createElement('img');
    ghost.src = img;
    ghost.alt = '';
    ghost.className = 'sq-ghost';
    var size = Math.min(a.width, 120);
    ghost.style.width = size + 'px';
    ghost.style.height = size + 'px';
    ghost.style.left = (a.left + a.width / 2 - size / 2) + 'px';
    ghost.style.top = (a.top + a.height / 2 - size / 2) + 'px';
    document.body.appendChild(ghost);
    var dx = (b.left + b.width / 2) - (a.left + a.width / 2), dy = (b.top + b.height / 2) - (a.top + a.height / 2);
    ghost.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(' + dx * 0.6 + 'px,' + (dy * 0.6 - 40) + 'px) scale(.5)', opacity: 0.9, offset: 0.6 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.15)', opacity: 0.2 }
    ], { duration: 650, easing: 'cubic-bezier(.4,0,.2,1)' }).onfinish = function () { ghost.remove(); };
  }

  function fromButton(btn) {
    var d = btn.dataset;
    var p = { id: d.variantId || '', handle: d.handle, title: d.title, vendor: d.vendor, img: d.img, url: d.url, qty: d.min || d.qty || 1, step: d.step || 1, variant: '', pack: d.pack || 0, min: d.min || 1 };
    var form = d.form ? document.getElementById(d.form) : null;
    if (form) {
      var idEl = form.elements['id'];
      if (idEl && idEl.length && !idEl.tagName) idEl = idEl[0];
      if (idEl && idEl.value) {
        p.id = idEl.value;
        var opt = idEl.tagName === 'SELECT' ? idEl.options[idEl.selectedIndex] : null;
        var vt = opt ? opt.textContent.trim() : '';
        var vjson = document.querySelector('[data-quote-variants="' + d.handle + '"]');
        if (vjson) { try { JSON.parse(vjson.textContent).forEach(function (v) { if (String(v.id) === String(p.id)) vt = v.title; }); } catch (e) {} }
        vt = vt.split(' - ')[0].trim();
        if (vt && vt !== 'Default Title') p.variant = vt;
      }
      var q = form.elements['quantity'];
      if (q && q.length && !q.tagName) q = q[0];
      if (q && parseInt(q.value, 10) > 0) p.qty = q.value;
    }
    return p;
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-quote-open]');
    if (open) { e.preventDefault(); openDrawer(); return; }
    var btn = e.target.closest('[data-quote-add]');
    if (!btn) return;
    e.preventDefault();
    var p = fromButton(btn);
    if (!api.add(p)) { showToast({ title: 'Your quote is full (40 lines). Send it, then start a new one.', img: '' }); return; }
    var media = btn.closest('.s-tile') ? btn.closest('.s-tile').querySelector('.s-tile__media') : document.querySelector('.product__main-photos, .product-single__media, .product-image-main');
    fly(media || btn, p.img);
    var label = btn.querySelector('[data-label]') || btn;
    var was = label.textContent;
    btn.classList.add('is-added');
    label.textContent = 'Added to quote';
    setTimeout(function () { btn.classList.remove('is-added'); label.textContent = was; }, 1800);
    showToast(p);
  });

  /* Product page: show what the chosen quantity means in packs and units */
  function packNote(wrapEl) {
    var input = wrapEl.querySelector('input');
    var note = wrapEl.parentNode.querySelector('[data-pack-note]');
    if (!input || !note) return;
    var q = parseInt(input.value, 10) || 0;
    var it = { pack: wrapEl.dataset.pack };
    var mn = parseInt(wrapEl.dataset.min, 10) || 1;
    note.textContent = q > 0 ? packText(it, q) + (q < mn ? '. Minimum ' + mn + (parseInt(it.pack, 10) > 1 ? ' packs' : ' units') + ' for this product.' : '') : '';
    note.classList.toggle('is-warn', q > 0 && q < mn);
  }
  document.querySelectorAll('[data-pack-qty]').forEach(function (w) {
    packNote(w);
    w.addEventListener('input', function () { packNote(w); });
    w.addEventListener('change', function () { packNote(w); });
    w.addEventListener('click', function () { setTimeout(function () { packNote(w); }, 30); });
  });

  window.addEventListener('storage', function (e) { if (e.key === KEY) { items = load(); render(); } });
  render();

  /* ---------- Quote request page: list the quote in step 3 and send it with the form ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    var box = document.querySelector('[data-quote-lines]');
    var form = document.getElementById('SQuoteForm');
    if (!form) return;
    var params = new URLSearchParams(location.search);
    if (params.get('contact_posted') === 'true' && location.hash === '#SQuoteForm') { items = []; save(); }
    var field = form.querySelector('[data-quote-field]');
    function paint() {
      if (!box) return;
      var wrap = box.closest('[data-quote-wrap]');
      if (wrap) wrap.hidden = items.length === 0;
      box.innerHTML = items.map(function (it) {
        return '<li class="sq-line" data-key="' + esc(it.key) + '">' + (it.img ? '<img src="' + esc(it.img) + '" alt="" width="48" height="48">' : '<span class="sq-line__ph"></span>') +
          '<span class="sq-line__text"><span class="sq-line__vendor">' + esc(it.vendor) + '</span><a href="' + esc(it.url) + '" target="_blank" rel="noopener">' + esc(it.title) + '</a>' + (it.variant ? '<span class="sq-line__variant">' + esc(it.variant) + '</span>' : '') + '</span>' +
          '<label class="sq-line__qty"><span class="visually-hidden">Quantity of ' + esc(it.title) + ', ' + esc(unitLabel(it)) + '</span><input type="number" min="' + (it.min || 1) + '" inputmode="numeric" value="' + it.qty + '"><span class="sq-line__unit">' + esc(packText(it)) + '</span></label>' +
          '<button type="button" class="s-link-btn" data-line-remove>Remove</button></li>';
      }).join('');
      var body = form.querySelector('#q-body');
      if (body) {
        body.required = items.length === 0;
        var req = form.querySelector('label[for="q-body"] .s-req');
        if (req) req.hidden = items.length > 0;
      }
    }
    if (box) {
      box.addEventListener('change', function (e) { var row = e.target.closest('[data-key]'); if (row) api.setQty(row.dataset.key, e.target.value); });
      box.addEventListener('click', function (e) { if (e.target.closest('[data-line-remove]')) { var row = e.target.closest('[data-key]'); api.remove(row.dataset.key); } });
      document.addEventListener('quote:change', paint);
      paint();
      if (items.length && params.get('from') === 'quote') {
        var sup = form.querySelector('[data-s-supplier]');
        var vendors = items.map(function (i) { return i.vendor; }).filter(function (v, i, a) { return v && a.indexOf(v) === i; });
        if (sup && vendors.length === 1) Array.prototype.forEach.call(sup.options, function (o) { if (o.value === vendors[0]) sup.value = o.value; });
      }
    }
    form.addEventListener('submit', function () {
      if (!field) return;
      field.value = items.map(function (it, i) {
        return (i + 1) + '. ' + packText(it) + ' x ' + it.title + (it.variant ? ' (' + it.variant + ')' : '') + ' | ' + it.vendor + ' | ' + location.origin + it.url.split('?')[0];
      }).join('\n');
    }, true);
  });
})();
